var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "layer-mobile position-relative h-100 vw-100 d-flex flex-column overflow-hidden"
  }, [_c('SearchItem', {
    ref: "search",
    staticClass: "block-searchform flex-shrink-0 py-3 px-4",
    on: {
      "submitCloseMenu": function submitCloseMenu($event) {
        return _vm.$emit('close-menu');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-shrink-1 pt-2 overflow-auto pt-2 overflow-momentum"
  }, [_c('NavItemTree', {
    ref: "tree",
    attrs: {
      "items": _vm.flattened,
      "with-color": ""
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('ul', {
    staticClass: "services list-unstyled mt-auto"
  }, _vm._l(_vm.services, function (service) {
    return _c('li', {
      key: service.id,
      staticClass: "item"
    }, [_c('a', {
      staticClass: "item-link",
      attrs: {
        "href": service.url
      },
      domProps: {
        "textContent": _vm._s(service.label)
      }
    })]);
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "footer p-3 m-0 list-unstyled"
  }, [_c('li', [_c('IconTextLink', {
    staticClass: "icon-text-link p-2",
    attrs: {
      "icon": 'infobulle',
      "label": _vm.$t('help'),
      "url": _vm.helpUrl,
      "theme": "dark"
    }
  })], 1), _vm._v(" "), _c('li', [_c('IconTextLink', {
    staticClass: "icon-text-link p-2",
    attrs: {
      "icon": 'geoloc',
      "label": _vm.$t('store'),
      "description": _vm.$t('store-description'),
      "url": _vm.storeLocUrl,
      "theme": "dark"
    }
  })], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };